<template>
  <div>
    <div class="section py-0 px-5">
      <div class="tile app-title">
        <p class="subtitle is-6">Ajouter un filtre</p>
      </div>
      <b-select v-model="selectedFiltreDynamiqueReseaux"
                :placeholder="listeFiltres[0]"
                expanded>
          <option
              v-for="filtre in listeFiltres"
              :value="filtre"
              :key="filtre">
              {{ filtre }}
          </option>
      </b-select>
    </div>
    <hr>
    <div :key="filtreReseaux.id" v-for="filtreReseaux in getFiltresDynamiquesReseaux">
      <component :is="filtreReseaux.app"
                 :propriete="filtreReseaux.id"
                 :label="filtreReseaux.label"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxLc-mutation-type';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import { TemplateFiltre, DataFiltre, ComputedFiltre, MethodsFiltre } from '@/components/general/baseFiltreDynamique';
import filtreAutoComplete from './filtreAutocomplete';

const venteReseauxLc = createNamespacedHelpers('venteReseauxLc');
const filterComponents = {};

[
  { key: 'format', title: 'Format' },
  { key: 'type', title: 'Type de réseau' },
].forEach((el) => {
  filterComponents[el.key] = {
    data: DataFiltre(el.key, el.title),
    computed: ComputedFiltre(venteReseauxLc.mapGetters, 'filtresDynamiquesReseauxSpe'),
    methods: MethodsFiltre(venteReseauxLc.mapMutations, venteReseauxLc.mapActions,
      types.REMOVE_FILTER_PROPERTY, types.ADD_FILTER_PROPERTY, 'gestionFiltresVentesReseaux'),
    template: TemplateFiltre,
  };
});

export default {
  name: 'ajout-filtre',
  components: {
    appFormat: filterComponents.format,
    appType: filterComponents.type,
    appFiltreAutoComplete: filtreAutoComplete,
  },
  data() {
    return {
      filtreDynamiqueVisible: false,
      listeFiltres: [FILTRE_DYNAMIQUE_VIDE, 'Ville', 'Département', 'Format', 'Type de réseau'],
    };
  },
  watch: {
    selectedFiltreDynamiqueReseaux() {
      const regAccentE = new RegExp('[éèêë]', 'gi');
      let value = this.selectedFiltreDynamiqueReseaux.toLowerCase().replace(regAccentE, 'e');
      if (value === 'departement') value = 'depCode';
      if (value === 'type de reseau') value = 'type';
      if (this.selectedFiltreDynamiqueReseaux !== FILTRE_DYNAMIQUE_VIDE) {
        let valueApp = value;
        if (value === 'ville' || value === 'depCode') valueApp = 'filtre-auto-complete';
        this.actionAjoutFiltresDynamiquesVentesReseaux({ property: value, valueProperty: { id: value, variable: value, valeur: [], app: 'app-' + valueApp } });
      }
    },
  },
  computed: {
    ...venteReseauxLc.mapGetters({
      filtresDynamiquesReseaux: 'filtresDynamiquesReseaux',
      getSelectedFiltreDynamiqueReseaux: 'selectedFiltreDynamiqueReseaux',
    }),
    selectedFiltreDynamiqueReseaux: {
      get() {
        return this.getSelectedFiltreDynamiqueReseaux;
      },
      set(value) {
        this.setSelectFiltreDynamique(value);
      },
    },
    getFiltresDynamiquesReseaux() {
      const tab = this.filtresDynamiquesReseaux;
      tab.forEach(el => {
        if (el.id === 'ville') el.label = 'Ville';
        if (el.id === 'depCode') el.label = 'Département';
        if (el.id === 'type') el.label = 'Type de réseau';
      });
      return tab;
    },
  },
  methods: {
    ...venteReseauxLc.mapMutations({
      setSelectFiltreDynamique: types.SELECT_FILTRE_DYNAMIQUE,
    }),
    ...venteReseauxLc.mapActions({
      actionAjoutFiltresDynamiquesVentesReseaux: 'ajoutFiltresDynamiquesVentesReseaux',
    }),
  },
};
</script>

<style scoped>

  select {
    padding-left:10px;
    padding-right: 10px;
    -webkit-appearance: none;
    border: 1px solid #dbdbdb;
    border-radius: 3px;
    color:#5E738B;
  }

  select:disabled{
    background-color: rgba(200, 200, 200, 0.2);
    border:none;
  }

  select:hover{
    border-color: #bfbfbf;
  }

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxLc/filtres/ajoutFiltre.vue